export default __webpack_public_path__ + "static/media/grid-canary-red.45dcb14f.png";